export default __webpack_public_path__ + "static/qrCodeImage-aedc48535a987e3b686ba031656f53c1.png";